import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  selectContainer: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: "4px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(4),
    },
  },
}))

export default styles
